import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PageTitleService } from 'app/core/page-title/page-title.service';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { ReportService } from 'app/services/report.service';
import { SpinnerService } from 'app/services/spinner.service';
import { UserService } from 'app/services/user/user.service';

@Component({
  selector: 'ms-candidate-privacy',
  templateUrl: './candidate-privacy.component.html',
  styleUrls: ['./candidate-privacy.component.css']
})
export class CandidatePrivacyComponent implements OnInit {

  requestNumber: any;
  uuid: any;

  submitted = false;
  showForm: Boolean = false;
  showMsg: Boolean = false;
  privacyForm: FormGroup;
  hrUserEmail: String;
  companyName: String;
  companyAddress: String;

  data: any;
  userData: any;
  notAgree: Boolean = true;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private reportService: ReportService,
    private spinnerService: SpinnerService,
    private formBuilder: FormBuilder,
    private commonUtilService: CommonUtilService,
    private userService: UserService,
    private pageTitleService: PageTitleService) { }

  ngOnInit(): void {
    this.spinnerService.start();

    this.pageTitleService.setTitle("Privacy");

    this.requestNumber = this.route.snapshot.paramMap.get('requestNumber');

    this.uuid = this.route.snapshot.paramMap.get('uuid');

    this.privacyForm = this.privacyFormBuilder(this.formBuilder);

    this.reportService.validateUUID(this.requestNumber, this.uuid).subscribe(data => {
      /* console.log(data); */
      this.data = data;
      if (this.data) {
        this.hrUserEmail = this.data.hrUserEmail;

        if (this.hrUserEmail !== null) {
          let dataJson = {
            'email': this.hrUserEmail
          }
          this.userService.getHrUserDetailsForCandidatePrivacy(dataJson).subscribe(userData => {
            this.userData = userData;
            /* console.log(this.userData); */

            this.showForm = this.data.validCandidate;
            this.privacyForm = this.privacyFormBuilder(this.formBuilder);
            this.showMsg = this.showForm ? false : true;

            this.companyName = this.userData.companyName;
            this.companyAddress = this.userData.companyAddress;
          });
        } else {
          this.showForm = this.data.validCandidate;
          this.showMsg = this.showForm ? false : true;
        }
      }
      this.spinnerService.stop();
    });

  }

  privacyFormBuilder = (formBuilder: FormBuilder) => {
    return formBuilder.group({
      privacyCheckbox: ['', [Validators.required]],
    });
  }

  notAgreeCheck() {
    this.notAgree = this.privacyForm.get('privacyCheckboxNotAgree').value;
  }

  get f() { return this.privacyForm.controls; }

  get val() { return this.privacyForm.value; }

  onSubmit() {
    this.spinnerService.start();
    //this.submitted = true;
    /* if (this.privacyForm.invalid) {
      this.commonUtilService.findInvalidControls(this.privacyForm);
      this.spinnerService.stop();
      return;
    } */

    this.reportService.updateCandidatePrivacy(this.requestNumber, this.uuid).subscribe(datas => {
      this.goToEntryPage();
      this.spinnerService.stop();
    }, err => {
      this.spinnerService.stop();
    });
  }

  onChange(e) {    
    if (e.target.value === 'yes') {
      this.submitted = true;
      this.notAgree = false;
    } else {
      this.submitted = false;
      this.notAgree = true;
    }
  }

  goToEntryPage() {
    this.router.navigate(['/report/' + this.requestNumber + '/' + this.uuid + '/entry']);
  }

}
